// extracted by mini-css-extract-plugin
export default {"container":"NewMenu_container__jKx9F"};